// 遅延時間（ミリ秒）※ここ調整すればOK
const DELAY = 1000;

// 初回ロード
window.addEventListener('load', () => {
  setTimeout(() => {
    showPrices();
  }, DELAY);
});

// Shopify セクション再読み込み対応
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    showPrices();
  }, DELAY);
});

function showPrices() {
  const targets = document.querySelectorAll(
    '.products-grid__price, .product-cta__price, .product-head__price, .products-grid__actions-cart, .products-grid__actions-favorite, .product-cta'
  );

  targets.forEach(element => {
    element.removeAttribute('hidden');
  });
}